/*

    Основная разметка страницы
*/


import './PageMain.css';


import React, { createRef, useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Authorize from '../Authorize/Authorize.js';
import TopMenu from '../TopMenu/TopMenu.js';
import Doctors from '../Doctors/Doctors.js';
import Find from '../Clients/Find.js';
import NewClient from '../Clients/NewClient.js';
import FormAnimal from '../Animals/FormAnimal.js';
import History from '../History/History.js';
import Manipulation from '../Manipulations/Manipulation.js';
import CheckItog from '../Check/CheckItog.js'



function PageMain(props) {

  // функция, которая будет вызвана из объекта выбора сотрудников
  // и которая заполнит их в объекте TopMenu
  function FillWorkersCount(data) { refTopMenu.current.FillWorkersCount(data); }

  // функция, которая будет вызвана из объекта выбора клиента
  // и которая заполнит его в объекте TopMenu
  function SelectedClient(client) { refTopMenu.current.SelectedClient(client); }

  // функция, которая будет вызвана из объекта выбора животного
  // и которая заполнит его в объекте TopMenu
  function SelectedAnimal(animal) { refTopMenu.current.SelectedAnimal(animal); }


  // функция, которая будет вызвана из объекта выбора манипуляций
  // и которая добавит манипуляцию в объекте TopMenu
  function AddManipulation(mp) { refTopMenu.current.AddManipulation(mp); }

  const refTopMenu = createRef();
  //console.log("aaa"+refTopMenu.current);
 
  return (    
    <>
        <div className="PageMain">
            <div className="container-fluid">

                <BrowserRouter>

                    <TopMenu onOutAuthorize={ props.onOutAuthorize } ref={ refTopMenu } />

                    <div className="row">                        
                            <Routes>                
                                <Route path="/entry" element={<Authorize />} />
                                <Route path="/doctors" element={<Doctors FillWorkersCount={ FillWorkersCount } />} />   
                                <Route path="/clients" element={<Find SelectedClient={ SelectedClient } SelectedAnimal={ SelectedAnimal } />} />
                                <Route path="/new_client" element={<NewClient SelectedClient={ SelectedClient } />} />

                                <Route path="/newanimal" element={<FormAnimal SelectedAnimal={ SelectedAnimal } />} />
                                <Route path="/history" element={<History />} />

                                <Route path="/manipulation" element={<Manipulation AddManipulation={ AddManipulation }/>} />
                                <Route path="/checkItog" element={<CheckItog AddManipulation={ AddManipulation }/>} />

                                <Route path="" element={<Doctors FillWorkersCount={ FillWorkersCount } />} />             
                            </Routes>                      
                    </div>
                </BrowserRouter>
            </div>
        </div>
    </>
  );
}

export default PageMain;

